import { CompressOutlined, ExpandOutlined, ZoomOutOutlined } from '@ant-design/icons'
import styles from './VideoViewport.module.css'

interface Props {
  isFullscreen: boolean
  isZoomed: boolean
  zoom: number
  onToggleFullscreen: () => void
  onResetView: () => void
  /** Render without absolute positioning — for dock chrome */
  inline?: boolean
}

export function VideoViewportControls({
  isFullscreen,
  isZoomed,
  zoom,
  onToggleFullscreen,
  onResetView,
  inline = false,
}: Props) {
  return (
    <div
      className={inline ? undefined : styles.controls}
      style={inline ? { display: 'inline-flex', alignItems: 'center', gap: 4 } : undefined}
      onPointerDown={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
    >
      {isZoomed ? (
        <>
          <span className={styles.zoomBadge}>{Math.round(zoom * 100)}%</span>
          <button
            type="button"
            className={styles.ctrlBtn}
            title="Сбросить зум"
            aria-label="Сбросить зум"
            onClick={onResetView}
          >
            <ZoomOutOutlined />
          </button>
        </>
      ) : null}
      <button
        type="button"
        className={`${styles.ctrlBtn} ${styles.ctrlBtnPrimary}`}
        title={isFullscreen ? 'Выйти из полного экрана' : 'Полный экран'}
        aria-label={isFullscreen ? 'Выйти из полного экрана' : 'Полный экран'}
        onClick={onToggleFullscreen}
      >
        {isFullscreen ? <CompressOutlined /> : <ExpandOutlined />}
      </button>
    </div>
  )
}
